import * as _ from 'lodash'
import axios from 'axios'

export default async (options) => {
    if (options.to.length === 0) throw new Error('no numbers')

    const credentials = Buffer.from(
        `${window.localStorage.getItem("username")}:${window.localStorage.getItem(
            "password"
        )}`
    ).toString("base64");

    let batches = _.chunk(options.to, 50)

    let promises = batches.map(batch => {
        return send({
            to: batch,
            message: options.message,
            unicode: options.unicode
        },
        credentials)     
    })
    await Promise.all(promises)

    return true

    
}

const send = async (options, credentials) => {
    return axios.post(
        "https://api.nomado.eu/sms/send",
        options,
        {
            headers: {
                Authorization: `Basic ${credentials}`
            }
        }
    );
}